export default {
  errors: null,
  taxRates: [],
  loading: false,
  count: 0,
  totalCount: 0
};
